<footer class="embed-footer w-100-percent ph-24 br-brand-primary-background">
    <span>{{ 'dashboard.poweredBy' | i18n }} <img src="/dashboard/img/QualtricsXM-Logo.png" height="16" alt="QualtricsXM-Logo"></span>
    <a class="btn-link float-right"
        rel="noopener"
        target="_blank"
        [i18n]="'dashboard.viewDashboardInXMDiscover'"
        [href]="linkToDashboard()">
    </a>
</footer>
